const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/messages/$uuid.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const messagesUuidSearchSchema = z.object({
  message_id: z.coerce.number().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/messages/$uuid")({
  validateSearch: messagesUuidSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});